// eslint-disable-next-line max-lines-per-function
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('HistoricoRecomendacoesService', HistoricoRecomendacoesService);

  HistoricoRecomendacoesService.$inject = [
    '$q',
    'filterFilter',
    '$routeParams',
    '$rootScope',
    'HistoricosService',
    'RecomendacoesService',
    '$route'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function HistoricoRecomendacoesService($q, filterFilter, $routeParams, $rootScope,
    HistoricosService, RecomendacoesService, $route) {
    const service = {
      updateRecommendationFilters,
      getFiltersList,
      loadRouteFilters,
      getFilteredPeriod
    };
    return service;

    function getFiltersList(tipo = 'recomendacao') {
      return $q.all([
        HistoricosService.listGruposInsumos(),
        RecomendacoesService.listAtividadesPeriodo(),
        HistoricosService.listUsuarios({ tipo })
      ]);
    }

    function loadRouteFilters({ recomendantes, statuses, gruposInsumo, atividades }) {
      let routeFilters = {};

      try {
        routeFilters = JSON.parse($routeParams.recommendationFilters);
      } catch {
        // error handler
      }

      const filteredPeriod = service.getFilteredPeriod();
      const dataInicial = filteredPeriod.dataInicial;
      const dataFinal = filteredPeriod.dataFinal;
      const period = filteredPeriod.periodo;
      const gleba = getFilterGleba(routeFilters);
      const recomendante = getFilterRecomendante(recomendantes, routeFilters);
      const status = getFilterStatus(statuses, routeFilters);
      const grupoInsumo = getFilterGrupoInsumo(gruposInsumo, routeFilters);
      const atividade = getFilterAtividade(atividades, routeFilters);

      return { gleba, dataInicial, dataFinal, period, recomendante, status, grupoInsumo, atividade };
    }

    // eslint-disable-next-line complexity
    function getFilteredPeriod() {
      const result = {
        dataInicial: null,
        dataFinal: null,
        periodo: {}
      };

      const routeDate = $routeParams.historyDate || $routeParams.date;

      if ($routeParams.recommendationFilters) {
        const filters = JSON.parse($routeParams.recommendationFilters);
        result.dataInicial = filters.dataInicial || routeDate;
        result.dataFinal = filters.dataFinal || routeDate;
        result.periodo = filters.period || {};
      } else if (routeDate) {
        result.dataInicial = routeDate;
        result.dataFinal = routeDate;
      }

      return formatPeriodAttributes(result);
    }

    function updateRecommendationFilters(recommendationFilters) {
      $route.updateParams({
        recommendationFilters: (function() {
          const result = {};
          Object.keys(recommendationFilters).forEach(function(key) {
            if (recommendationFilters[key] && key !== 'page') {
              if (recommendationFilters[key]._isAMomentObject) {
                result[key] = recommendationFilters[key].format(MOMENT_DATE_ENGLISH_FORMAT);
              } else if (recommendationFilters[key].id) {
                result[key] = recommendationFilters[key].id;
              } else {
                result[key] = recommendationFilters[key];
              }
            }
          });
          return JSON.stringify(result);
        }())
      });
    }

    function getFilterGleba(routeFilters) {
      routeFilters.gleba = routeFilters.gleba || +$routeParams.activeGleba;

      if (routeFilters.gleba) {
        const glebas = $rootScope.currentPropriedade.glebas;
        return filterFilter(glebas, { id: routeFilters.gleba }, true)[0];
      }
    }

    function getFilterRecomendante(recomendantes, routeFilters) {
      if (routeFilters.recomendante && recomendantes) {
        return filterFilter(recomendantes, { id: routeFilters.recomendante }, true)[0];
      }
    }

    function getFilterStatus(statuses, routeFilters) {
      if (routeFilters.status && statuses) {
        return filterFilter(statuses, { id: routeFilters.status }, true)[0];
      }
    }

    function getFilterGrupoInsumo(gruposInsumo, routeFilters) {
      if (routeFilters.grupoInsumo && gruposInsumo) {
        return gruposInsumo.find((grupo) => (
          grupo.id[0] === routeFilters.grupoInsumo[0] && grupo.id[1] === routeFilters.grupoInsumo[1]
        ));
      }
    }

    function getFilterAtividade(atividades, routeFilters) {
      if (routeFilters.atividade && atividades) {
        return filterFilter(atividades, { id: routeFilters.atividade })[0];
      }
    }

    function formatPeriodAttributes(result) {
      if (result.dataInicial && _.isEmpty(result.periodo)) {
        if (result.dataInicial === result.dataFinal) {
          result.periodo.periodo = moment(result.dataInicial).format(DATE_FORMAT.toUpperCase());
        } else {
          const startDate = moment(result.dataInicial).format(DATE_FORMAT.toUpperCase());
          const endDate = moment(result.dataFinal).format(DATE_FORMAT.toUpperCase());
          result.periodo.periodo = `${startDate} à ${endDate}`;
        }
      }

      return result;
    }
  }
}());
